import { hasToolCall, stepCountIs } from "ai";
import {
	getChatOnlyToolNames,
	getReadOnlyToolNames,
	isAgentBoardMutationToolName,
} from "./tool-registry";

export const AGENT_CHAT_MAX_TOOL_STEPS = 10;
export const AGENT_CHAT_MAX_HISTORY_MESSAGES = 40;
export const AGENT_CHAT_MAX_PLAN_STEPS = 40;

export const CHAT_ONLY_TOOL_NAMES = getChatOnlyToolNames();

export const READ_ONLY_BOARD_TOOL_NAMES = getReadOnlyToolNames();

/**
 * streamText / ToolLoopAgent stopWhen: halt after presentOptions (user must
 * pick before more tools run) or when the max tool-step budget is hit.
 */
export function stopWhenPresentOptionsOrMaxSteps() {
	return [
		hasToolCall("presentOptions"),
		stepCountIs(AGENT_CHAT_MAX_TOOL_STEPS),
	];
}

export function isAgentBoardMutationTool(toolName: string) {
	return isAgentBoardMutationToolName(toolName);
}

export type BoardToolsEditableFilter = {
	editable?: boolean;
};

export function filterBoardToolsForEditable<
	TOOLS extends Record<string, unknown>,
>(tools: TOOLS, filter: BoardToolsEditableFilter | null | undefined): TOOLS {
	if (filter?.editable !== false) {
		return tools;
	}

	return Object.fromEntries(
		Object.entries(tools).filter(([toolName]) =>
			READ_ONLY_BOARD_TOOL_NAMES.has(toolName),
		),
	) as TOOLS;
}

/** @deprecated Use filterBoardToolsForEditable */
export function filterBoardToolsForSnapshot<
	TOOLS extends Record<string, unknown>,
>(tools: TOOLS, snapshot: BoardToolsEditableFilter | null | undefined): TOOLS {
	return filterBoardToolsForEditable(tools, snapshot);
}

export const AGENT_CHAT_TELEMETRY = {
	isEnabled: true,
	functionId: "agent-chat",
} as const;
